import { useAppContext } from "../../context/appContext";
import React from "react";

export function withUser(Component) {
    return function WrappedComponent(props) {
      const { user, logoutUser, loginUser, errorMessage, successMessage, sendResetEmail, isLoading } = useAppContext();
      return <Component {...props} user={user} logoutuser={logoutUser} loginuser={loginUser} errorMessage={errorMessage} successMessage={successMessage} sendResetEmail={sendResetEmail} isLoading={isLoading}/>;
    }
  }